module.exports = __webpack_public_path__ + "static/media/crm-icon-inactive.438fae1f.svg";